import File from './File.component';
import FileTextMode from './displayMode/TextMode.component';

export { FileTextMode };
export default File;
